<template>
    <div class="progress">
        <div class="banner"></div>
        <div class="profile">
            <div class="profile-header">
                <div class="title">
                    <div class="cont_tit">
                        <p>{{ title }}</p>
                        <span>{{ englishTitle }}</span>
                    </div>
                    <div class="crumb">
                        <span>当前位置：</span>
                        <a href="../" target="_self" title="首页" class="CurrChnlCls">首页</a>&gt;<a href="" target="_self"
                            :title="title" class="CurrChnlCls">{{
                            title
                        }}</a>
                    </div>
                </div>
            </div>
            <div class="profile-conter">
                <ul class="conter-ul" v-if="dataList.length > 0">
                    <li class="conter-li" v-for="(item, index) in dataList" :key="index">
                      <a
                          :href="
                            'https://www.jobhb.com/zoneDetails?id=' +
                            item.reRecruitProjectId +
                            '&title=' +
                            item.title
                          "
                          target="_blank"
                        >
                        <!-- <router-link :to="{
                            path: '/zoneDetails',
                            query: { id: item.reRecruitProjectId, title: item.title },
                        }"> -->
                            <img class="image" :src="item.src" alt="" />
                            <div>{{ item.title }}</div>
                        <!-- </router-link> -->
                        </a>
                    </li>
                </ul>
                <div class="box-body" v-else>
                    <div class="body-d">
                        <img src="../assets/images/zwsj.png" alt=""></img>
                        <div class="text"> 敬请期待 ~ </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getReRecruitProjectList, getPreviewUrl } from "@/api/index";
export default {
  name: "events",
  data() {
    return {
      title: "",
      englishTitle: "",
      translationDict: {
        海外专区: "Overseas zone",
        国企专区: "Special zone for state-owned enterprises",
        地方专区: "Local zone",
        校招专区: "School recruitment area",
      },
      dataList: [],
    };
  },
  created() {
    let regionId = this.$route.query.id;
    this.title = this.$route.query.title;
    this.ReRecruitProjectList(regionId);
    this.translate();
  },
  methods: {
    translate() {
      this.englishTitle = "";
      const words = this.title.split(" ");
      for (let word of words) {
        this.englishTitle += `${this.translationDict[word] || word} `;
      }
    },

    //招聘项目列表
    async ReRecruitProjectList(regionId) {
      await getReRecruitProjectList(regionId).then((res) => {
        if (res.code == 200) {
          res.data.forEach(async (item, i) => {
            if (item.visible == 1) {
              this.dataList.push({
                reRecruitProjectId: item.reRecruitProjectId,
                src: "",
                title: item.projectName,
                num: item.count,
              });
              await this.PreviewUrl(item, i);
            }
          });
        }
      });
    },

    async PreviewUrl(item, i) {
      await getPreviewUrl(item.webProjectPic).then((response) => {
        this.dataList[i].src = response.msg;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("../assets/images/cyzcpc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}

.profile {
  width: 70%;
  margin: auto;

  &-header {
    padding-top: 50px;
    margin-bottom: 50px;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .cont_tit {
      position: relative;
      font-weight: 800;
    }

    .cont_tit:after {
      content: "";
      position: absolute;
      background: url("../assets/images/index20231114_8.png") center center
        no-repeat;
      background-size: 100% auto;
      width: 450px;
      height: 56px;
      left: -10px;
      bottom: -30px;
    }

    .cont_tit p {
      display: inline-block;
      font-size: 30px;
      padding-right: 20px;
      line-height: 1.1;
      position: relative;
      margin-right: 20px;
      font-weight: 600;
      color: #335593;
    }

    .cont_tit p:after {
      content: "";
      position: absolute;
      height: 28px;
      width: 3px;
      left: 100%;
      bottom: 0;
      background: #7499ce;
    }

    .cont_tit span {
      display: inline-block;
      font-size: 14px;
      color: #b1b1b1;
    }

    .title .crumb {
      color: #585858;
      font-size: 18px;
    }

    .title .crumb a {
      margin: 0 10px;
      display: inline-block;
    }
  }

  &-conter {
    .conter-ul {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      margin-top: 5%;

      .conter-li {
        background-color: #fff;
        box-shadow: 0px 9px 20px 0px #c2c1c180;
        box-sizing: content-box;
        margin-bottom: 20px;
        margin-right: 2%;
        padding: 15px 1%;
        width: 30%;

        .image {
          width: 100%;
          height: 12vw;
        }
      }

      .conter-li:nth-child(3n) {
        margin-right: 0;
      }
    }

    .box-body {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      .body-d {
        width: 200px;
        height: 300px;

        img {
          width: 100%;
        }

        .text {
          text-align: center;
          color: #a3a3a3;
        }
      }
    }
  }
}
</style>